import React, { ComponentProps } from 'react'
import { Field } from 'src/shared/components/field'
import type {
  WebsiteFormFieldsSettings,
  WebsiteThemeInterface,
} from 'src/shared/types/website-settings-types'

export interface PublicPageFieldProps extends ComponentProps<typeof Field> {
  formFields?: Partial<WebsiteFormFieldsSettings>
  theme?: WebsiteThemeInterface
}

export const PublicPageField: React.FC<PublicPageFieldProps> = ({
  type,
  name,
  formFields,
  theme,
  value,
  onChange,
}) => {
  const border = formFields?.border
    ? {
        ...formFields.border,
        color: theme?.formFields.formFieldBorderColor,
      }
    : undefined

  return (
    <Field
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      fontFamily={formFields?.typography?.fontFamily}
      padding={formFields?.padding}
      lineHeight={formFields?.typography?.lineHeight}
      mobileLineHeight={formFields?.typography?.mobileLineHeight}
      textAlign={formFields?.typography?.textAlign}
      mobileTextAlign={formFields?.typography?.mobileTextAlign}
      border={border}
      backgroundColor={theme?.formFields.formFieldBackgroundColor}
      color={theme?.formFields.formFieldTextColor}
      fontSize={formFields?.typography?.fontSize}
      mobileFontSize={formFields?.typography?.mobileFontSize}
    />
  )
}
